(() => {
  if (customElements.get('pa-height-guide')) return;
  let nextId = 0;
  const number = value => {
    const text = String(value).trim().replace(',', '.');
    return /^\d+(?:\.\d+)?$/.test(text) ? Number(text) : NaN;
  };
  class HeightGuide extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.content = this.closest('.pa-size-guide-content');
      this.input = this.querySelector('[data-height-input]');
      this.error = this.querySelector('[data-height-error]');
      this.result = this.querySelector('[data-height-result]');
      this.unit = 'cm';
      this.cm = null;
      this.submitted = false;
      const allowed = (this.dataset.garmentRows || '').split(';').map(row => row.split('|')[0].trim().toUpperCase()).filter(size => /^(XS|S|M|L|XL|XXL)$/.test(size));
      this.ranges = (this.dataset.heightRanges || '').split(';').filter(row => row.trim()).map(row => {
        const [size, min, max, ...extra] = row.split('|').map(cell => cell.trim());
        return { size, min: number(min), max: number(max), extra: extra.length };
      });
      if (!this.ranges.length || !this.ranges.every(row => !row.extra && allowed.includes(row.size) && row.min >= 80 && row.max <= 250 && row.min <= row.max)) return;
      const id = `pa-height-${++nextId}`;
      this.querySelector('[data-height-help]').id = `${id}-help`;
      this.error.id = `${id}-error`;
      this.input.setAttribute('aria-describedby', `${id}-help ${id}-error`);
      this.input.addEventListener('input', () => {
        this.read();
        this.error.hidden = true;
        this.input.removeAttribute('aria-invalid');
        this.render();
      });
      this.input.addEventListener('keydown', event => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.submit();
        }
      });
      this.querySelector('[data-height-submit]').addEventListener('click', () => this.submit());
      this.content.addEventListener('click', event => {
        const button = event.target.closest('[data-pa-unit]');
        if (!button) return;
        const unit = button.dataset.paUnit;
        if (unit === this.unit) return;
        this.unit = unit;
        this.input.value = this.cm === null ? '' : String(Number((unit === 'inches' ? this.cm / 2.54 : this.cm).toFixed(unit === 'inches' ? 2 : 1)));
        this.querySelector('[data-height-unit]').textContent = unit === 'inches' ? 'in' : 'cm';
        this.error.hidden = true;
        this.input.removeAttribute('aria-invalid');
        this.render();
      });
      this.hidden = false;
    }
    read() {
      const raw = number(this.input.value);
      const cm = Math.round((this.unit === 'inches' ? raw * 2.54 : raw) * 10) / 10;
      this.cm = Number.isFinite(cm) && cm >= 80 && cm <= 250 ? cm : null;
    }
    submit() {
      this.read();
      this.submitted = true;
      const invalid = this.cm === null;
      this.error.hidden = !invalid;
      this.input.toggleAttribute('aria-invalid', invalid);
      if (invalid) {
        this.input.setAttribute('aria-invalid', 'true');
        this.input.focus();
      }
      this.render();
    }
    render() {
      const show = this.submitted && this.cm !== null;
      const sizes = show ? this.ranges.filter(row => this.cm >= row.min && this.cm <= row.max).map(row => row.size) : [];
      this.result.hidden = !show;
      this.querySelector('[data-height-match]').hidden = !sizes.length;
      this.querySelector('[data-height-outside]').hidden = Boolean(sizes.length);
      this.querySelector('[data-height-sizes]').textContent = sizes.join(' / ');
      this.content.querySelectorAll('tbody tr').forEach(row => {
        row.toggleAttribute('data-height-suggested', sizes.includes(row.querySelector('th')?.textContent.trim().toUpperCase()));
      });
    }
  }
  customElements.define('pa-height-guide', HeightGuide);
})();
